import React, { useState } from 'react';
import routes from '../../Utils/routes.json';
import Home from '@material-ui/icons/Home';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import MailIcon from '@material-ui/icons/Mail';
import SmsIcon from '@material-ui/icons/Sms';
import EventAvailableOutlinedIcon from '@material-ui/icons/EventAvailableOutlined'; // event
import TableChartOutlinedIcon from '@material-ui/icons/TableChartOutlined'; //time table
import {
  Grid,
  IconButton,
  makeStyles,
  Menu,
  ListItem,
  Typography,
  Box,
  withStyles,
  List,
  Tooltip,
} from '@material-ui/core';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import Logo from '../../Assets/ken42-logo.jpg';
import DashboardIcon from '@material-ui/icons/Dashboard';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import {
  FaClipboardCheck,
  FaMoneyBill,
  FaSearchDollar,
  FaMoneyCheck,
  FaPercentage,
  FaRupeeSign,
  FaChessQueen,
  FaUserFriends,
  FaUserEdit,
  FaRegUserCircle,
  FaSatelliteDish,
} from 'react-icons/fa';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import PeopleIcon from '@material-ui/icons/People';
import CastIcon from '@material-ui/icons/Cast';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import PaymentIcon from '@material-ui/icons/Payment';
import AllOutIcon from '@material-ui/icons/AllOut';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import ReceiptIcon from '@material-ui/icons/Receipt';
import SchoolIcon from '@material-ui/icons/School';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import CancelIcon from '@material-ui/icons/Cancel';
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import RestoreIcon from '@material-ui/icons/Restore';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import CategoryIcon from '@material-ui/icons/Category';
import ViewQuiltSharpIcon from '@material-ui/icons/ViewQuiltSharp';
import ListAltSharpIcon from '@material-ui/icons/ListAltSharp';
import SupervisedUserCircleSharpIcon from '@material-ui/icons/SupervisedUserCircleSharp';
import AlarmOffSharpIcon from '@material-ui/icons/AlarmOffSharp';
import InsertInvitationSharpIcon from '@material-ui/icons/InsertInvitationSharp';
import LocationCitySharpIcon from '@material-ui/icons/LocationCitySharp';
import GroupWorkSharpIcon from '@material-ui/icons/GroupWorkSharp';
import AccountBalanceWalletSharpIcon from '@material-ui/icons/AccountBalanceWalletSharp';
import EventNoteIcon from '@material-ui/icons/EventNote';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AssignmentIcon from '@material-ui/icons/Assignment';
import InfoIcon from '@material-ui/icons/Info';
import DescriptionIcon from '@material-ui/icons/Description';
import SubjectIcon from '@material-ui/icons/Subject';
import MoneyIcon from '@material-ui/icons/Money';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import NestedMenuItem from './NestedMenuItem';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import CustomMenuItem from './CustomMenuItem';
import { useTranslation } from 'react-i18next';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import { ArrowDropDownCircleRounded } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    color: '#03248F',
    '&:hover': {
      textDecoration: 'none',
      color: '#fff',
    },
    '&:focus': {
      textDecoration: 'none',
      color: '##03248F',
    },
  },
  listItem: {
    padding: '12px 20px',
    backgroundColor: 'inherit',
  },
  heading: {
    fontSize: 14,
    // fontWeight: 600,
    color: theme.palette.KenColors.sideNavColor,
    marginLeft: 28,
    marginTop: '-8px',
  },
  menuIcon: {
    color: theme.palette.KenColors.kenWhite,
  },
  logo: {
    height: '48px',
    background: theme.palette.KenColors.kenWhite,
    marginLeft: 12,
  },
  closeIcon: {
    marginRight: 8,
    color: theme.palette.KenColors.kenWhite,
    cursor: 'pointer',
  },
  closeLeftIcon: {
    color: theme.palette.KenColors.kenWhite,
    cursor: 'pointer',
  },
  menuButton: {
    marginLeft: 8,
  },
  hide: {
    display: 'none',
  },
  activeLinkInner: {
    backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    color: '#fff',
  },
  activeLinkOuter: {
    backgroundColor: theme.palette.KenColors.sideNavBackground,
  },
  menuTitle: {
    color: theme.palette.KenColors.kenWhite,
    padding: '16px',
  },
  popover: {
    // marginTop: '-25px',
    backgroundColor: '#F2F2F2',
  },
  listRoot: {
    // backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    backgroundColor: 'red',
    color: 'inherit',
    opacity: 'inherit',
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    },
  },
  list: {
    padding: 0,
    margin: 0,
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    },
  },
  icon: {
    color: theme.palette.KenColors.kenWhite,
    fontSize: 14,
  },
  item: {
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    },
  },
  fa: {
    fontSize: '22px',
    marginRight: '0.5rem',
  },
  header: {
    padding: '8px 16px',
    color: '#03248F',
    fontSize: '14px',
    fontWeight: 600,
  },
  headerClass: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 8,
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);

export const SideNavigation = (props) => {
  const { openDrawer, setOpenDrawer } = props;
  const classes = useStyles();
  const [menuPosition, setMenuPosition] = useState(null);
  const [selectedSubItems, setSelectedSubItems] = useState([]);
  const { t } = useTranslation();

  const subMenus = [
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Dashboard',
      path: routes.exam,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Student Status',
      path: routes.studentStatus,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Question Paper',
      path: routes.questionPaper,
      path: routes.questionPaper,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Timetable & Seating plan',
      path: routes.seatingPlan,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Invigilation & Proctoring',
      path: routes.invigilationProctoring,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Evaluation',
      path: routes.evaluation,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Grading',
      path: routes.grading,
    },
    {
      icon: <DashboardIcon className={classes.subMenuIcon} />,
      label: 'Revaluation & Retest',
      path: routes.revaluationRetest,
    },
  ];

  const menus = [
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Exam',
      path: routes.exam,
      subItems: subMenus,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Fee',
      // path: routes.currentCoursemes,
    },
    {
      icon: <ArrowDropDownCircleRounded />,
      label: 'Communication',
      // path: routes.addCourse,
    },
  ];

  // const menus = [
  //   { icon: <Home />, label: 'Home', path: `/dashboard`, callback: '' },
  //   {
  //     icon: <FaSatelliteDish />,
  //     label: t('labels:Communication_Channels'),
  //     callback: '',
  //     subItems: [
  //       {
  //         icon: <NotificationsActiveIcon />,

  //         label: t('labels:Notification'),
  //         path: `/${Routes.notification}`,
  //         //   callback: '',
  //       },
  //       {
  //         icon: <MailIcon />,
  //         label: t('labels:Mail'),
  //         path: `/${Routes.sendMail}`,
  //         callback: '',
  //       },
  //       {
  //         icon: <SmsIcon />,
  //         label: t('labels:SMS'),
  //         path: `/${Routes.sendSMS}`,
  //         callback: '',
  //       },
  //     ],
  //   },
  //   {
  //     icon: <EventAvailableOutlinedIcon />,
  //     label: t('labels:Events'),
  //     path: `/${Routes.events}`,
  //     callback: '',
  //   },
  //   {
  //     icon: <TableChartOutlinedIcon />,
  //     label: t('labels:Timetable'),
  //     path: `/${Routes.timeTable}`,
  //     callback: '',
  //   },
  //   {
  //     icon: <PaymentIcon />,
  //     label: t('labels:Fee_Management'),
  //     //   path: `/${Routes.timeTable}`,
  //     subItems: [
  //       {
  //         icon: <DashboardIcon />,
  //         label: t('labels:Dashboard'),
  //       },
  //       {
  //         icon: <FaMoneyBill className={classes.fa} />,
  //         label: t('labels:Transactions'),
  //         subItems: [
  //           {
  //             icon: <FaMoneyCheck className={classes.fa} />,
  //             label: t('labels:Demand_Note'),
  //           },
  //           {
  //             icon: <CollectionsBookmarkIcon />,
  //             label: t('labels:Collect_Payment'),
  //           },
  //           {
  //             icon: <ReceiptIcon />,
  //             label: t('labels:Send_Receipt'),
  //           },
  //           {
  //             icon: <SchoolIcon />,
  //             label: t('labels:Scholarships'),
  //           },
  //           {
  //             icon: <MonetizationOnIcon />,
  //             label: t('labels:Loans'),
  //           },
  //           {
  //             icon: <FaPercentage className={classes.fa} />,
  //             label: t('labels:Concessions'),
  //           },
  //           {
  //             icon: <RestorePageIcon />,
  //             label: t('labels:Refund'),
  //           },
  //           {
  //             icon: <CancelIcon />,
  //             label: t('labels:Cancel_Transaction'),
  //           },
  //         ],
  //       },
  //       {
  //         icon: <NoteAddIcon />,
  //         label: t('labels:Tasks'),
  //       },
  //       {
  //         icon: <FaClipboardCheck className={classes.fa} />,
  //         label: t('labels:Reconciliation'),
  //       },
  //       {
  //         icon: <AssessmentIcon className={classes.fa} />,
  //         label: t('labels:Reports'),
  //         subItems: [
  //           {
  //             icon: <TableChartOutlinedIcon />,
  //             label: t('labels:Application'),
  //           },
  //           {
  //             icon: <FaRupeeSign className={classes.fa} />,
  //             label: t('labels:Fee_Related'),
  //             subItems: [
  //               {
  //                 icon: <FaMoneyCheck className={classes.fa} />,
  //                 label: t('labels:Demand_Note'),
  //               },
  //               {
  //                 icon: <CollectionsBookmarkIcon />,
  //                 label: t('labels:Fee_Collection'),
  //               },
  //               {
  //                 icon: <RestoreIcon />,
  //                 label: t('labels:Fee_Pending'),
  //               },
  //               {
  //                 icon: <TableChartOutlinedIcon />,
  //                 label: t('labels:Defaulters'),
  //               },
  //               {
  //                 icon: <RestorePageIcon />,
  //                 label: t('labels:Fee_Refund'),
  //               },
  //               {
  //                 icon: <SpeakerNotesIcon />,
  //                 label: t('labels:Student_Statement'),
  //               },
  //             ],
  //           },
  //           {
  //             icon: <MonetizationOnIcon />,
  //             label: t('labels:Loans_Scholarships'),
  //             subItems: [
  //               {
  //                 icon: <MonetizationOnIcon />,
  //                 label: t('labels:Loans'),
  //               },
  //               {
  //                 icon: <SchoolIcon />,
  //                 label: t('labels:Scholarships'),
  //               },
  //             ],
  //           },
  //           {
  //             icon: <FaMoneyCheck className={classes.fa} />,
  //             label: t('labels:Cheque/DD'),
  //           },
  //           {
  //             icon: <SwapHorizontalCircleIcon />,
  //             label: t('labels:Receivables'),
  //           },
  //           {
  //             icon: <FaChessQueen className={classes.fa} />,
  //             label: t('labels:Royalty'),
  //           },
  //           {
  //             icon: <TableChartOutlinedIcon />,
  //             label: t('labels:Application'),
  //           },
  //           {
  //             icon: <FaMoneyCheck className={classes.fa} />,
  //             label: t('labels:Demand_Note'),
  //           },
  //           {
  //             icon: <CollectionsBookmarkIcon />,
  //             label: t('labels:Fees_Collection'),
  //           },
  //           {
  //             icon: <RestoreIcon />,
  //             label: t('labels:Fee_Pending'),
  //           },
  //           {
  //             icon: <SwapHorizontalCircleIcon />,
  //             label: t('labels:Receivables'),
  //           },
  //         ],
  //       },
  //       {
  //         icon: <SettingsApplicationsIcon />,
  //         label: t('labels:Fee_Configuration'),
  //         subItems: [
  //           {
  //             icon: <CategoryIcon />,
  //             label: t('labels:Fee_Types'),
  //           },
  //           {
  //             icon: <ViewQuiltSharpIcon />,
  //             label: t('labels:Fee_Structure'),
  //           },
  //           {
  //             icon: <ListAltSharpIcon />,
  //             label: t('labels:Fee_Inventory'),
  //           },
  //           {
  //             icon: <SupervisedUserCircleSharpIcon />,
  //             label: t('labels:Student_Fee_Mapping'),
  //           },
  //         ],
  //       },
  //       {
  //         icon: <FaSearchDollar className={classes.fa} />,
  //         label: t('labels:Setup'),
  //         subItems: [
  //           {
  //             icon: <PeopleIcon />,
  //             label: t('labels:Users'),
  //           },
  //           {
  //             icon: <AllOutIcon />,
  //             label: t('labels:Masters'),
  //             subItems: [
  //               {
  //                 icon: <GroupWorkSharpIcon />,
  //                 label: t('labels:Franchises'),
  //               },
  //               {
  //                 icon: <LocationCitySharpIcon />,
  //                 label: t('labels:Campuses'),
  //               },
  //               {
  //                 icon: <PeopleIcon />,
  //                 label: t('labels:Students'),
  //               },
  //               {
  //                 icon: <SchoolIcon />,
  //                 label: t('labels:Program_Plan'),
  //               },
  //               {
  //                 icon: <InsertInvitationSharpIcon />,
  //                 label: t('labels:Payment_Schedule'),
  //               },
  //               {
  //                 icon: <NotificationsActiveIcon />,
  //                 label: t('labels:Reminders'),
  //               },
  //               {
  //                 icon: <AccountBalanceWalletSharpIcon />,
  //                 label: t('labels:Installments'),
  //               },
  //               {
  //                 icon: <AlarmOffSharpIcon />,
  //                 label: t('labels:Late_Fees'),
  //               },
  //               {
  //                 icon: <CategoryIcon />,
  //                 label: t('labels:Categories'),
  //               },
  //               {
  //                 icon: <FaPercentage className={classes.fa} />,
  //                 label: t('labels:Concessions'),
  //               },
  //               {
  //                 icon: <SchoolIcon />,
  //                 label: t('labels:Scholarships'),
  //               },
  //               {
  //                 icon: <MonetizationOnIcon />,
  //                 label: t('labels:Loans'),
  //               },
  //             ],
  //           },
  //           {
  //             icon: <SettingsApplicationsIcon />,
  //             label: t('labels:Settings'),
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     icon: <FaMoneyBill className={classes.fa} />,
  //     label: t('labels:Payroll_Management'),
  //     //   path: `/${Routes.timeTable}`,

  //     subItems: [
  //       {
  //         icon: <FaMoneyBill className={classes.fa} />,
  //         label: t('labels:My_Payroll'),
  //         subItems: [
  //           {
  //             icon: <ViewQuiltSharpIcon />,
  //             label: t('labels:Salary_Structure'),
  //           },
  //           {
  //             icon: <MonetizationOnIcon />,
  //             label: t('labels:Salary_Plan'),
  //           },
  //           {
  //             icon: <FormatAlignJustifyIcon />,
  //             label: t('labels:FBP_Submission'),
  //           },
  //           {
  //             icon: <DescriptionIcon />,
  //             label: t('labels:Payslips'),
  //             path: `${Routes.mypayslip}`,
  //           },
  //           {
  //             icon: <MoneyIcon />,
  //             label: t('labels:Investments'),
  //             path: `${Routes.investment}`,
  //           },
  //           {
  //             icon: <SubjectIcon />,
  //             label: t('labels:Form16'),
  //           },
  //         ],
  //       },
  //       {
  //         icon: <EventNoteIcon />,
  //         label: t('labels:My_Leaves'),

  //         subItems: [
  //           {
  //             icon: <EventBusyIcon />,
  //             label: t('labels:My_Leaves'),
  //           },
  //           {
  //             icon: <EventNoteIcon />,
  //             label: t('labels:Leave_Summary'),
  //           },
  //           {
  //             icon: <EventAvailableIcon />,
  //             label: t('labels:My_Attendance'),
  //           },
  //         ],
  //       },
  //       {
  //         icon: <SettingsBackupRestoreIcon />,
  //         label: t('labels:My_Reimbursement'),
  //       },
  //       {
  //         icon: <ExitToAppIcon />,
  //         label: t('labels:My_Exit'),
  //       },
  //       {
  //         icon: <AssignmentIcon />,
  //         label: t('labels:My_Tasks'),
  //       },
  //       {
  //         icon: <InfoIcon />,
  //         label: t('labels:Information'),
  //         subItems: [
  //           {
  //             icon: <InfoIcon />,
  //             label: t('labels:Company_Policies'),
  //           },
  //         ],
  //       },
  //       {
  //         icon: <FaSearchDollar className={classes.fa} />,
  //         label: t('labels:Setup'),
  //         subItems: [
  //           {
  //             icon: <AllOutIcon />,
  //             label: t('labels:Masters'),

  //             subItems: [
  //               {
  //                 icon: <GroupWorkSharpIcon />,
  //                 label: t('labels:Departments'),
  //                 path: `${Routes.department}`,
  //               },
  //               {
  //                 icon: <LocationCitySharpIcon />,
  //                 label: t('labels:Bank_Accounts'),
  //                 path: `${Routes.bankaccount}`,
  //               },
  //               {
  //                 icon: <PeopleIcon />,
  //                 label: t('labels:Employees'),
  //                 path: `${Routes.employee}`,
  //               },
  //               {
  //                 icon: <SchoolIcon />,
  //                 label: t('labels:Designations'),
  //                 path: `${Routes.designation}`,
  //               },
  //               {
  //                 icon: <InsertInvitationSharpIcon />,
  //                 label: t('labels:Payslip_Structure'),
  //                 path: `${Routes.payslip}`,
  //               },
  //               {
  //                 icon: <NotificationsActiveIcon />,
  //                 label: t('labels:Shift_Schedules'),
  //                 path: `${Routes.shift}`,
  //               },
  //               {
  //                 icon: <AccountBalanceWalletSharpIcon />,
  //                 label: t('labels:Working_Days'),
  //                 path: `${Routes.workingday}`,
  //               },
  //               {
  //                 icon: <AlarmOffSharpIcon />,
  //                 label: t('labels:Leave_Policies'),
  //                 path: `${Routes.leavepolicy}`,
  //               },
  //               {
  //                 icon: <CategoryIcon />,
  //                 label: t('labels:Holiday_List'),
  //                 path: `${Routes.holiday}`,
  //               },
  //             ],
  //           },
  //           {
  //             icon: <SettingsApplicationsIcon />,
  //             label: t('labels:Settings'),
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     icon: <FaUserFriends className={classes.fa} />,
  //     label: t('labels:Manage_Roles'),
  //     subItems: [
  //       {
  //         icon: <FaRegUserCircle className={classes.fa} />,
  //         label: t('labels:Assign_Roles'),
  //         path: `${Routes.assignRoles}`,
  //       },
  //       {
  //         icon: <FaUserEdit className={classes.fa} />,
  //         label: t('labels:View_Edit_Roles'),
  //       },
  //     ],
  //   },
  // ];

  const handleMenuClick = (event, item) => {
    if (Array.isArray(item.subItems) && item?.subItems?.length > 0) {
      setSelectedSubItems(item);
      if (menuPosition) {
        return;
      }
      event.preventDefault();
      let currentTargetRect = event.currentTarget.getBoundingClientRect();
      const event_offsetX = currentTargetRect.top - 25;
      const event_offsetY = currentTargetRect.right;

      setMenuPosition({
        top: event_offsetX,
        left: event_offsetY,
      });
    } else {
      setSelectedSubItems([]);
      return;
    }
  };

  const handleItemClick = (event) => {
    setMenuPosition(null);
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const customRender = (items) => {
    if (!Array.isArray(items)) return <></>;
    return items?.map((item, index) => {
      if (item.subItems) {
        return (
          <NestedMenuItem
            label={item.label}
            parentMenuOpen={!!menuPosition}
            PaperProps={{ className: classes.popover }}
            icon={item.icon}
            index={index}
            header={item.label}
          >
            {customRender(item.subItems)}
          </NestedMenuItem>
        );
      }
      return item?.path ? (
        <NavLink
          key={index}
          className={classes.link}
          to={item?.path}
          activeClassName={classes.activeLinkInner}
          exact
        >
          <CustomMenuItem
            key={index}
            onClick={handleItemClick}
            icon={item.icon}
            label={item.label}
            openDrawer={openDrawer}
          ></CustomMenuItem>
        </NavLink>
      ) : (
        <CustomMenuItem
          key={index}
          onClick={handleItemClick}
          icon={item.icon}
          label={item.label}
          openDrawer={openDrawer}
          className={classes.icon}
        ></CustomMenuItem>
      );
    });
  };

  return (
    <div>
      <Box className={classes.root}>
        <Grid className={classes.headerClass}>
          {openDrawer === true ? (
            <>
              <img src={Logo} className={classes.logo} alt="logo" />
              <div className={classes.toolbar}>
                <FormatAlignRightIcon
                  onClick={handleDrawerClose}
                  className={classes.closeIcon}
                />
              </div>
            </>
          ) : (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={classes.menuButton}
            >
              <FormatAlignLeftIcon className={classes.closeLeftIcon} />
            </IconButton>
          )}
        </Grid>
      </Box>
      <List>
        {menus?.map((item, index) => (
          <>
            <NavLink
              key={index}
              className={classes.link}
              onClick={(e) => handleMenuClick(e, item)}
              to={
                item?.path === null || item?.path === undefined ? (
                  <Typography>{item?.path}</Typography>
                ) : (
                  item?.path
                )
              }
              activeClassName={classes.activeLinkOuter}
              exact
            >
              <ListItem
                classes={{
                  root: classes.listItem,
                  //   selected: classes.active,
                }}
                button
              >
                {openDrawer === false ? (
                  <LightTooltip title={item.label} placement="right-end">
                    <span className={classes.menuIcon}>
                      <Typography>{item.icon}</Typography>
                    </span>
                  </LightTooltip>
                ) : (
                  <span className={classes.menuIcon}>
                    <Typography>{item.icon}</Typography>
                  </span>
                )}
                <span className={classes.heading}>{item?.label}</span>
              </ListItem>
            </NavLink>
            {selectedSubItems && (
              <Menu
                open={!!menuPosition}
                onClose={() => setMenuPosition(null)}
                anchorReference="anchorPosition"
                anchorPosition={menuPosition}
                PaperProps={{
                  className: classes.popover,
                  elevation: 1,
                }}
                header={item?.label}
              >
                <Typography variant="body1" className={classes.header}>
                  {selectedSubItems?.label}
                </Typography>
                {customRender(selectedSubItems?.subItems)}
              </Menu>
            )}
          </>
        ))}
      </List>
    </div>
  );
};

export default SideNavigation;
